<template>
<div class="TestpaperQuesEdit">
    <div class="filters">
        <div class="add">
            <el-button type="primary" @click="openQueImport">试题中导入</el-button>
            <el-button type="primary" @click="openExcelImport">EXCEL导入</el-button>
        </div>
        <div class="search"></div>
    </div>
    <div class="total" v-show="dataList.length>0">共{{dataList.length}}题，合计{{topicScore()}}分</div>
    <div class="tq-body" v-show="dataList.length>0">
        <div class="left">
            <questionSetting :dataList="dataList"></questionSetting>
        </div>
        <div class="right">
            <!--列表-->
            <questionList :dataList="dataList"></questionList>
        </div>
    </div>
    <!--暂无数据-->
    <div class="noData" v-show="dataList.length<1">
        <img :src="require('@/common/images/other/zwsj@2x.png')" alt="">
        <p>当前暂无试题，请前往试题添加题目</p>
    </div>
    <div class="saveBtn"  v-show="dataList.length>0">
        <el-button @click="cancelChange">取消</el-button>
        <el-button type="primary" @click="saveChange">保存</el-button>
    </div>
    <excelImport  @getQuesInfo="getQuesInfo" ref="excelImport"></excelImport>
    <questionbankImport @getQueList="getQueList" ref="questionbankImport"></questionbankImport>
</div>
</template>

<script>
import {getExampaperQuesList,saveAllCwKmcQuestionbankuserexamquestioninfo} from 'api/testPaperApi'
import {mapGetters, mapActions} from 'vuex'
import QuestionSetting from 'views/operateTool/testpaper/components/questionSetting.vue'
import QuestionList from 'views/operateTool/testpaper/components/questionList.vue'
import ExcelImport from 'views/operateTool/testpaper/components/excelImport.vue'
import QuestionbankImport from 'views/operateTool/testpaper/components/questionbankImport.vue'
import SubEdit from 'views/operateTool/testpaper/components/subEdit.vue'
import {letter} from 'api/enumCode'
export default {
    name: 'TestpaperQuesEdit',
    data() {
        return {
            dataList:'',
        }
    },
    created(){
      //检测更改题型分数
        this.$bus.on('changeTopicScore',(val)=>{
            this.dataList.forEach(item=>{
                if(item.questiontype == val.ind){
                    this.$set(item,'defaultscore',val.score)
                }
            })
        });
        //编辑
        this.$bus.on('canceltopicEdit',(val)=>{
            this.$bus.emit('showSettingAll',1)
            if(val.type == 'cancel'){
                this.$set(this.dataList[val.ind],'editShow' , false);
            }else{
                let arr = JSON.parse(val.data)
                arr.questionindex = val.ind+1;
                // if(arr.questionindex=1){
                //     arr.questiontypename = '单选题'
                // }else if(arr.questionindex==2){
                //     arr.questiontypename = '多选题'
                // }else if(arr.questionindex==3){
                //     arr.questiontypename = '不定项选择题'
                // }else if(arr.questionindex==4){
                //     arr.questiontypename = '判断题'
                // }else if(arr.questionindex==5){
                //     arr.questiontypename = '填空题'
                // }else if(arr.questionindex==6){
                //     arr.questiontypename = '问答题'
                // }
                if (arr.questiontype == 7) {
                    arr = this._setFormatQues([arr])[0]
                }
                this.$set(this.dataList, val.ind, arr);
                this.$set(this.dataList[val.ind],'editShow' , false);
            }
        })
        //移动
        this.$bus.on('changeMove',(val)=>{
            if(val.move=='up'){
                this.$set(this.dataList,val.index,this.dataList.splice(val.index-1,1,this.dataList[val.index])[0])
                this.reloadIndex()
            }else if(val.move=='down'){
                this.$set(this.dataList,val.index,this.dataList.splice(val.index+1,1,this.dataList[val.index])[0])
                this.reloadIndex()
            }
        });
        //删除
        this.$bus.on('topicDel',(val)=>{
            this.$confirm('是否删除该试题?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
            }).then(() => {
                this.dataList.splice(val.index,1);
                this.reloadIndex();
            }).catch(() => {

            });
        })
    },
    mounted() {
        this._getList()
    },
    methods: {
        saveChange(){
            this.setLoading(true);
            let list = this._setFormatQues(this._.cloneDeep(this.dataList))
            let params = {
                content:JSON.stringify(list),
                examinnerid:this.$route.query.id || ''
            }
            saveAllCwKmcQuestionbankuserexamquestioninfo({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.$message.success('操作成功')
                    this.$router.push({name: 'TestpaperList'})
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        //取消 回到上页
        cancelChange(){
            this.$router.go(-1);
        },
        reloadIndex(){
          this.dataList.forEach((item,index)=>{
              this.$set(item,'questionindex',index+1);
          })
        },
        _getList(){
            this.setLoading(true);
            let params = {
                innerid:this.$route.query.id
            }
            getExampaperQuesList({
                data: Object.assign({}, params),
                success: data => {
                    this.dataList = this._getFormatQues(data.data.content)
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        // 打开题库中导入弹窗
        openQueImport(){
            this.$refs.questionbankImport.openDialog(this.$route.query.id)
        },
        // 打开Excel导入弹窗
        openExcelImport() {
            this.$refs.excelImport.openDialog(this.$route.query.id)
        },
        // 导入EXCEL 成功 重新调取接口
        getQuesInfo() {
            this._getList()
        },
        getQueList(){
            this._getList()
        },
        _setFormatQues(data) {
            let arr = []
            data.forEach(item=>{
                if (item.questiontype == 7) {
                    item.questioninfo.forEach((obj, index) => {
                        if (['1','2','3'].indexOf(obj.questiontype) > -1) {
                            console.log(obj)
                            let list = []
                            let optioninfo = []
                            obj.optionslist.forEach((obj, index) => {
                                optioninfo.push({
                                    id: '',
                                    isrightanswer: obj.isrightanswer * 1,
                                    optionsinfo: obj.optionsinfo
                                })
                                list.push({
                                    optionsvalue: letter[index],
                                    optionsinfo: obj.optionsinfo,
                                    isrightanswer: obj.isrightanswer
                                })
                            })
                            obj.optionslist = optioninfo
                            obj.finalanswerblank = {}
                            obj.optioninfo = []
                        } else if (['5'].indexOf(obj.questiontype) > -1) {
                            let item = {answerblank: obj.finalanswer.split('|')}
                            obj.finalanswerblank = item
                            obj.optionslist = []
                            obj.optioninfo = []
                        } else {
                            obj.finalanswerblank = {}
                            obj.optionslist = []
                            obj.optioninfo = []
                        }
                    })
                }
                let{innerid,defaultscore,optionslist,subject,questiontype,finalanswer,isquesorder,
                    isscorebyblank,referenceanswer,optioncount,questionindex,quesanalysis, questioninfo} = item
                arr.push({innerid,defaultscore,optionslist,subject,questiontype,finalanswer,isquesorder,
                    isscorebyblank,referenceanswer,optioncount,questionindex,quesanalysis, questioninfo})
            })
            return arr
        },
        _getFormatQues(data) {
            data.forEach(item => {
                if(item.questiontype == '5'){
                    this.$set(item,'finalanswer',item.finalanswerblank.answerblank.join('|'))
                }
                if (item.questiontype ==7) {
                    let list = []
                    item.questioninfo.forEach((obj, index) => {
                        let finalanswer = ''
                        if (obj.questiontype + '' == 4) {
                            finalanswer = obj.finalanswer
                        } else  if (obj.questiontype + '' == 5) {
                            finalanswer = obj.finalanswerblank.answerblank.join('|')
                        }
                        list.push({
                            innerid: obj.innerid,
                            subject: obj.subject,
                            questiontype: obj.questiontype + '',
                            cateid: obj.cateid ? obj.cateid : '',
                            defaultscore: obj.defaultscore,
                            quesanalysis: obj.quesanalysis,
                            isquesorder: obj.isquesorder,
                            isscorebyblank: obj.isscorebyblank,
                            referenceanswer: obj.referenceanswer,
                            finalanswer: finalanswer,
                            finalanswerblank: obj.questiontype + '' == 5 ? obj.finalanswerblank : [],
                            optioninfo: obj.optionslist ? obj.optionslist : [],
                            optionslist: obj.optionslist ? obj.optionslist : []
                        })
                    })
                    item.questioninfo = list
                }
            })
            return data
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        topicScore:function () {
            return function () {
                if(this.dataList.length>0){
                    let totalScore = 0
                    this.dataList.forEach(item=>{
                        totalScore+=Number(item.defaultscore)
                    });
                    return totalScore
                }
            }
        },
        ...mapGetters([
            'permission'
        ])
    },
    components: {
        QuestionSetting, QuestionList,ExcelImport,QuestionbankImport,SubEdit
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.TestpaperQuesEdit {
    min-height: 600px;
    .noData{
        text-align: center;
        color: #999;
        img{
            width: 372px;
            height: 270px;
        }
    }
    font-size: 14px;
    .total{
        color: #303133;
        margin-bottom: 20px;
    }
    .tq-body{
        display: flex;
        justify-content: flex-start;
        .left{
            margin-right: 20px;
            margin-top: -20px;
        }
        .right{
            flex-grow: 1;
            margin-bottom: 20px;
        }
    }
    .el-radio{
        margin-right: 0;
    }
    .dialog-footer{
        text-align: center;
        border-top: none;
    }
    .saveBtn{
        position: fixed;
        bottom: 0;
        left: 200px;
        background: #fff;
        height: 50px;
        width: 100%;
        padding-top: 20px;
        text-align: center;
        z-index: 999;
    }
}
</style>
